import { yupResolver } from "@hookform/resolvers/yup";
import { Box } from "@mui/material";
import { AutoCompleteMenu } from "atoms";
import { FormContainer } from "components";
import { actionsData, editDistributionFormData } from "data";
import { useEditDistribution } from "hooks";
import { PropTypes } from "prop-types";
import { useForm } from "react-hook-form";
import { useSelector } from "react-redux";
import { useEditDistributionSchema } from "schemas";
import { renderFormControllerHandler } from "utils";

const EditReleaseDistributionForm = ({
    clientId,
    jobId,
    releaseId,
    setModalData,
    territoryId,
}) => {
    const schema = useEditDistributionSchema();

    const selections = useSelector((state) => state.selectionsReducer);

    const formMethods = useForm({
        mode: "onChange",
        resolver: yupResolver(schema),
    });

    const {
        control,
        formState: { errors },
        watch,
    } = formMethods;

    const {
        editDistribution,
        loading,
    } = useEditDistribution(
        watch("editDistributionType"),
        setModalData,
    );

    const renderFormControllerChildrenHandler = (
        field,
        label,
        name,
        type,
        isOptional,
        selectionKey,
    ) => (
        <Box mb={1}>
            <AutoCompleteMenu
                errors={errors}
                getRenderedOption={(option) => option.label}
                label={label}
                name={name}
                optionLabel={(option) => option.label}
                options={selections?.[selectionKey]}
                onChange={(__, option) => {
                    if (option) field.onChange(option.value);
                    else field.onChange("");
                }}
            />
        </Box>
    );

    return (
        <FormContainer
            action={actionsData.save}
            formMethods={formMethods}
            loading={loading}
            setModalData={setModalData}
            data={renderFormControllerHandler(
                control,
                editDistributionFormData,
                renderFormControllerChildrenHandler,
            )}
            hasCancelButton
            withoutShadow
            onSubmitForm={() => editDistribution(
                clientId,
                jobId,
                releaseId,
                territoryId,
            )}
        />
    );
};

export default EditReleaseDistributionForm;

EditReleaseDistributionForm.propTypes = {
    clientId: PropTypes.number,
    jobId: PropTypes.number,
    releaseId: PropTypes.number,
    setModalData: PropTypes.func,
    territoryId: PropTypes.number,
};
